import React, {Component} from 'react'
import {STATUS} from "../../helpers/filterLists"
import {Select} from "antd"
import 'antd/lib/select/style/index.css'
import PropTypes from 'prop-types'

const {Option} = Select

class FilterStatus extends Component {
    _handleChange = (value) => {
        const {onChangeFilters} = this.props
        const filters = Object.assign({}, this.props.filters)

        if (typeof onChangeFilters === 'function') {
            onChangeFilters({
                ...filters,
                status: value
            })
        }
    }

    render() {
        const {filters} = this.props
        const {status} = filters
        const field = 'status'

        return (
            <div className="FilterShippingCarrier mb-3 mr-3">
                <label className='font-weight-bold d-block'>Trạng thái</label>
                <Select
                    style={{width: 300}}
                    showArrow={true}
                    placeholder="Vui lòng chọn lý do bạn muốn tìm kiếm"
                    defaultValue={status}
                    onChange={this._handleChange}
                    value={status}
                >
                    {
                        STATUS.map((option, index) => {

                            const {name, value} = option

                            return <Option key={`${field}_${value}_${index + 1}`} value={value}>{name}</Option>
                        })
                    }
                </Select>
            </div>
        )
    }
}

FilterStatus.propTypes = {
    filters: PropTypes.object.isRequired
}

export default FilterStatus